

























export default {
	name: 'SidebarItem',

	props: {
		tab: {
			required: true,
			type: Object,
		},
	},

	methods: {
		goToPage() {
			if (this.tab.disabled) return;

			if (this.tab.path) {
				return this.$router.push(this.localePath({ path: this.tab.path }));
			}

			this.logout();
		},

		logout() {
			this.$store.dispatch('login/logout').then(() => {
				this.$toast.success('Successfully logged out!');

				this.$router.push(this.localePath({ path: '/login' }));
			});
		},
	},
};
